export const getInitialProps = async ({
  routeInfo,
  context: {
    domain,
    i18n: {culture}
  }
}) => {
  const {
    location: {pathname: path, search}
  } = routeInfo

  const {pageName} = await domain.get('get_page_name_page_use_case').execute({path})

  const getSeoData = () => domain.get('get_seo_data_use_case').execute({culture, pageName})

  const getInitialTargetPage = () =>
    domain
      .get('get_target_page_name_page_use_case')
      .execute({path: search})
      .then(({targetPage} = {}) => targetPage)

  const [[seoDataError, {head: helmet} = {}], targetPage] = await Promise.all([getSeoData(), getInitialTargetPage()])

  return {
    helmet,
    pageName,
    targetPage,
    seoDataError,
    __HTTP__: {
      headers: [{'Cross-Origin-Opener-Policy': 'same-origin-allow-popups'}]
    }
  }
}
